import React, { Component } from 'react';
import { BodyText, Button, DropdownMenu, HeadingText, Link, Modal } from '@paypalcorp/pp-react';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import BrexitComponent from '../components/BrexitComponent';
import { getComplaintsPageInfo, isComplaintsCountryLocaleEnabled } from '../../lib/globalHelper';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';

const complaintsTextInfo = getComplaintsPageInfo();

const complaintsTranslations = {
  submitHeader: i18n.message('smarthelp/complaints.complaintsPage.submitHeader'),
  payPalText: i18n.message('smarthelp/complaints.complaintsPage.payPalText'),
  xoomText: i18n.message('smarthelp/complaints.complaintsPage.xoomText'),
  zettleText: i18n.message('smarthelp/complaints.complaintsPage.zettleText'),
  hyperWalletText: i18n.message('smarthelp/complaints.complaintsPage.hyperWalletText'),
  brainTreeText: i18n.message('smarthelp/complaints.complaintsPage.brainTreeText'),
  modalPageTitle: i18n.message('smarthelp/complaints.complaintsPage.modalPageTitle'),
  modalPageHeader: i18n.message('smarthelp/complaints.complaintsPage.modalPageHeader'),
  modalSelectDefault: i18n.message('smarthelp/complaints.complaintsPage.modalSelectDefault'),
  modalContinue: i18n.message('smarthelp/complaints.complaintsPage.modalContinue'),
  modalSelectOption1: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption1'),
  modalSelectOption2: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption2'),
  modalSelectOption3: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption3'),
  modalSelectOption4: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption4'),
  modalSelectOption5: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption5'),
  modalSelectOption6: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption6'),
  modalSelectOption7: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption7'),
  modalSelectOption8: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption8'),
  modalSelectOption9: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption9'),
};

class BrexitComplaintsContainer extends Component {
  static goToArticlePage(currentArticle) {
    trackLink({ id: 'complaintsPage', link: 'smarthelp-complaints-page', hpid: currentArticle.articleId });
  }

  static handleKeyPress(event, article) {
    if (event.which === 13) {
      BrexitComplaintsContainer.goToArticlePage(article);
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      errorText: '',
      complaintSelectedValue: '',
    };
    this.renderModal = this.renderModal.bind(this);
  }

  componentDidMount() {
    // Impression  event for complains page
    trackPage({ id: 'complaintsPageLoad', link: 'smarthelp-complaints-page' });
  }

  // eslint-disable-next-line
  complaintsLinkClick(urlClicked) {
    trackLink({ id: 'complaintsPage', link: `smarthelp-complaints-page-complaints-link-clicked|${urlClicked}` });
  }

  /**
   * Redirect to complaints page only when the drop down value is selected
   */
  redirectComplaintsPage() {
    const { complaintSelectedValue } = this.state;
    if (!complaintSelectedValue) {
      this.setState({
        errorText: 'Required',
      });
    } else {
      trackLink({
        id: 'complaintsPageModal',
        link: `smarthelp-paypal-complaints-modal-continue-clicked|${complaintSelectedValue}`,
      });
      window.location.href = `/smarthelp/contact-us/complaints?complaint_reason=${complaintSelectedValue}&locale.x=${Page.getAPILocalilty()}`;
    }
  }

  formValueChanged(e) {
    this.setState({
      errorText: '',
    });
    this.setState({
      complaintSelectedValue: e.target.value,
    });
    trackPage({ id: 'complaintsPageModal', link: `smarthelp-complaints-reason-dropdown-change|${e.target.value}` });
  }

  // See a summary of our complaints data.
  /**
   * Complaints Page html content
   */
  complaintsPage() {
    const complaintOptions = [
      {
        primaryText: complaintsTranslations.modalSelectOption1,
        value: 'FEEDCOMPLAIN011',
      },
      {
        primaryText: complaintsTranslations.modalSelectOption2,
        value: 'FEEDCOMPLAIN012',
      },
      {
        primaryText: complaintsTranslations.modalSelectOption3,
        value: 'FEEDCOMPLAIN013',
      },
      {
        primaryText: complaintsTranslations.modalSelectOption4,
        value: 'FEEDCOMPLAIN014',
      },
      {
        primaryText: complaintsTranslations.modalSelectOption5,
        value: 'FEEDCOMPLAIN015',
      },
      {
        primaryText: complaintsTranslations.modalSelectOption6,
        value: 'FEEDCOMPLAIN016',
      },
      {
        primaryText: complaintsTranslations.modalSelectOption7,
        value: 'FEEDCOMPLAIN017',
      },
      {
        primaryText: complaintsTranslations.modalSelectOption8,
        value: 'FEEDCOMPLAIN018',
      },
      {
        primaryText: complaintsTranslations.modalSelectOption9,
        value: 'FEEDCOMPLAIN019',
      },
    ];
    return (
      <div>
        <BrexitComponent
          renderSubmitComplaint={this.renderSubmitComplaint()}
          complaintsLinkClick={(urlClicked) => this.complaintsLinkClick(urlClicked)}
        />
        <Modal
          hideLogo
          overpanel
          title={complaintsTranslations.modalPageTitle}
          isOpen={this.state.isModalOpen}
          center
          onClose={() => this.renderModal(false)}
        >
          <HeadingText size="lg">{complaintsTranslations.modalPageHeader}</HeadingText>
          <br />
          <DropdownMenu
            label={complaintsTranslations.modalSelectDefault}
            theme="v2"
            options={complaintOptions}
            errorText={this.state.errorText}
            onChange={(e) => this.formValueChanged(e)}
            value={this.state.complaintSelectedValue}
          />
          <br />
          <Button theme="v2" onClick={() => this.redirectComplaintsPage()}>
            {complaintsTranslations.modalContinue}
          </Button>
        </Modal>
      </div>
    );
  }

  /**
   * Function to render complaints link based on the url and text passed
   */
  renderComplaintLink(complaintText, contactUrl, contactText) {
    if (contactUrl && contactText) {
      return (
        <BodyText className="complaints-contact-channel">
          <Link
            href={contactUrl}
            onClick={() => this.complaintsLinkClick(contactUrl)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {complaintText}
          </Link>
          &nbsp;
          {contactText}
        </BodyText>
      );
    }
    return <div />;
  }

  renderModal(value) {
    if (value) {
      trackLink({ id: 'complaintsPage', link: 'smarthelp-complaints-page-paypal-complaints-link-clicked' });
    } else {
      trackLink({ id: 'complaintsPageModal', link: 'smarthelp-complaints-page-paypal-complaints-modal-closed' });
    }
    this.setState({
      isModalOpen: value,
      complaintSelectedValue: '',
    });
  }

  /**
   * Add this in RC
   */
  renderPayPalComplaintLink(isComplaintMarketEnabled) {
    if (isComplaintMarketEnabled) {
      return (
        <BodyText className="complaints-contact-channel">
          <Link onClick={() => this.renderModal(true)} target="_blank" rel="noopener noreferrer">
            {complaintsTranslations.submitHeader}
          </Link>
          &nbsp;
          {complaintsTranslations.payPalText}
        </BodyText>
      );
    }
    return (
      <BodyText className="complaints-contact-channel">
        <Link onClick={() => this.renderModal(true)} target="_blank" rel="noopener noreferrer">
          {complaintsTextInfo.submitComplaint}
        </Link>
        {complaintsTextInfo.paypalText}
      </BodyText>
    );
  }

  renderSubmitComplaint() {
    // zettleDisabledMarkets
    const isComplaintMarketEnabled = isComplaintsCountryLocaleEnabled();
    const country = Page.getCountry().toUpperCase();
    const xoomUrl = complaintsTextInfo.xoomComplaintUrl;
    // getting the zettle url from Remote config based on country
    // update RC to hide zettle links for few markets
    const isZettleDisabled =
      complaintsTextInfo.zettleDisabledMarkets && complaintsTextInfo.zettleDisabledMarkets.indexOf(country) >= 0;
    let iZettleUrl = '';
    let iZettleText = '';

    // Do not add link/text to zettle disabled markets
    if (!isZettleDisabled) {
      iZettleUrl =
        (complaintsTextInfo[country] && complaintsTextInfo[country].iZettleComplaintUrl) ||
        complaintsTextInfo.iZettleComplaintUrl;
      iZettleText = isComplaintMarketEnabled ? complaintsTranslations.zettleText : complaintsTextInfo.iZettleText;
    }

    const hyperwalletUrl = complaintsTextInfo.hyperwalletUrl;
    const braintreeUrl = complaintsTextInfo.brainTreeUrl;
    const complaintText = isComplaintMarketEnabled
      ? complaintsTranslations.submitHeader
      : complaintsTextInfo.submitComplaint;
    const xoomText = isComplaintMarketEnabled ? complaintsTranslations.xoomText : complaintsTextInfo.xoomText;

    const hyperwalletText = isComplaintMarketEnabled
      ? complaintsTranslations.hyperWalletText
      : complaintsTextInfo.hyperwalletText;
    const brainTreeText = isComplaintMarketEnabled
      ? complaintsTranslations.brainTreeText
      : complaintsTextInfo.brainTreeText;

    if (complaintText) {
      return (
        <div className="brexit-complaints-page-div__common-div">
          <HeadingText className="brexit-complaints-page-div__common-div__submit-complaint">
            {complaintText}
          </HeadingText>
          {this.renderPayPalComplaintLink(isComplaintMarketEnabled)}
          {this.renderComplaintLink(complaintText, xoomUrl, xoomText)}
          {this.renderComplaintLink(complaintText, iZettleUrl, iZettleText)}
          {this.renderComplaintLink(complaintText, hyperwalletUrl, hyperwalletText)}
          {this.renderComplaintLink(complaintText, braintreeUrl, brainTreeText)}
        </div>
      );
    }

    return <div />;
  }

  render() {
    return this.complaintsPage();
  }
}

export default BrexitComplaintsContainer;
